/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Suspense } from 'react'

import { RouteLoader } from '@/components/feedbacks'

export function lazyImport<T extends React.ComponentType<any>, I extends { [K2 in K]: T }, K extends keyof I>(
  factory: () => Promise<I>,
  name: K
): I {
  const LazyComponent = React.lazy(() => factory().then((module) => ({ default: module[name] })))

  return Object.create({
    [name]: (props: any) => (
      <Suspense fallback={<RouteLoader />}>
        <LazyComponent {...props} />
      </Suspense>
    ),
  })
}

// Usage
// const { Home } = lazyImport(() => import("./Home"), "Home");
